import { useEffect, useState } from "react";
import usePartDefaultCategories from "../../../data/usePartDefaultCategories";
import useShipping from "../../../data/useShipping";
import { IShippingAddress, IShippingDimensions } from "../../../models/Shipping";
import { IPart } from "../../../models/Part";
import { resolveAddress, resolveDimensions } from "../../ebayOrders/CreateShippingLabelsModal";
import LoadingWheel from "../../shared/LoadingWheel";
import { FedexShipping } from "./FedexShipping";
import { ProoviaShipping } from "./ProoviaShipping";

export default function ShippingProviders({ 
  part, 
  provider,
  shippingService,
  setShippingService,
  setProoviaItemId,
  setProoviaCollection,
  setProoviaDelivery
}: { 
  part: IPart, 
  provider: number, 
  shippingService: string | undefined, 
  setShippingService: (value: string | undefined) => void ,
  setProoviaItemId: (value: number) => void,
  setProoviaCollection: (value: string) => void,
  setProoviaDelivery: (value: string) => void
}){
  const { shippingInfo }        = useShipping(part);
  const { defaultPartCategory } = usePartDefaultCategories({ part });

  // -------- Address -------- //
  const [address, setAddress] = useState<IShippingAddress>();
  const [addressLoading, setAddressLoading] = useState(true);

  useEffect(() => {
    if (!shippingInfo.isLoading && shippingInfo.data) {
      setAddress(resolveAddress(part, shippingInfo));
      setAddressLoading(false);
    }
  }, [shippingInfo.isLoading, shippingInfo.data]);

  // -------- Dimensions -------- //
  const [dimensions, setDimensions] = useState<IShippingDimensions>();
  const [dimensionsLoading, setDimensionsLoading] = useState(true);

  useEffect(() => {
    if (!defaultPartCategory.isLoading && defaultPartCategory.data) {
      setDimensions(resolveDimensions(part, defaultPartCategory));
      setDimensionsLoading(false);
    }

    if (!part.categoryId) {
      setDimensionsLoading(false);
    }
  }, [defaultPartCategory.isLoading, defaultPartCategory.data]);


  if (addressLoading || dimensionsLoading) return <LoadingWheel />;

  return (
    <>
      {
        {
            0: (
              <FedexShipping
                address={address!}
                dimensions={dimensions!}
                part={part}
                onServiceSelect={(svc: any) => setShippingService(svc)}
                selectedService={shippingService}
              />
            ),
            1: (
              <ProoviaShipping
                address={address!}
                dimensions={dimensions!}
                part={part}
                onProoviaItemSelect={(item) => setProoviaItemId(item)}
                onCollectionSlotSelect={(slot) =>
                  setProoviaCollection(slot)
                }
                onDeliverySlotSelect={(slot) =>
                  setProoviaDelivery(slot)
                }
                onServiceSelect={(svc) => setShippingService(svc)}
                selectedService={shippingService}
              />
            ),
        }[provider] 
      }
    </>
  )
}